import { getPurchaseContractDetail } from "@/apis/contract.api";
import { BusinessId } from "@/components/ModalHost/type";
import { useQuery } from "@tanstack/react-query";

export function useContractRecordQuery(recordId: BusinessId) {
  const result = useQuery({
    queryKey: ["getPurchaseContractDetail", recordId],
    queryFn: () => getPurchaseContractDetail(recordId!),
    enabled: !!recordId,
  });

  if (!recordId) return;

  return result.data?.data.data;
}
